import { Tenant } from "./tenant";
import { Organization } from "./organization";
import { EntitiesAndSensorIdentifier } from "./entities-and-sensor-identifier";

export class CepRule {
  nameComplexRule: string;
  ruleState: string;
  tenant: Tenant;
  organization: Organization;
  simpleRules: SimpleCepRule[];
  lastEvaluation: boolean;
  triggeredDate: number;
  lastValueEvaluated: string;
  evaluationDate: number;
  lastSensorEvaluated: string;
}

export class SimpleCepRule {
  name: string;
  entitiesAndSensorIdentifiers: EntitiesAndSensorIdentifier[];
  aggregatorFunctionType: string;
  limitOperatorType: string;
  limitValue: number;
  windowTime: number;
  transformationOption: boolean;
  transformationType: string;
  transformationValue: string;
  lastEvaluation: boolean;
  triggeredDate: number;
  lastValueEvaluated: string;
  evaluationDate: number;

  constructor(name: string, entitiesAndSensorIdentifiers: EntitiesAndSensorIdentifier[], limitValue: number, windowTime: number) {
    this.name = name;
    this.entitiesAndSensorIdentifiers = entitiesAndSensorIdentifiers;
    this.limitValue = limitValue;
    this.windowTime = windowTime;
    this.transformationOption = false;
  }
}
